export default class Customer {
  constructor() {
    this.first_name = '';
    this.last_name = '';
    this.email = '';
    this.email_confirmation = '';
    this.company = '';
    this.address = '';
    this.city = '';
    this.state_id = '';
    this.zip = '';
    this.phone = '';
  }
}
